export const getReportTabs = (account) => {
  const hasFlag = name => (account?.flags || []).some(flag => flag.name === name);
  return [
    { path: "overview", label: "Overview" },
    // {
    //   label: "Communication Analytics",
    //   subItems: [
    //     { path: "communication-overview", label: "Communication" },
    //     { path: "response-time-analytics", label: "Response Time Analytics" },
    //     { path: "team-performance", label: "Team Performance" },
    //     { path: "property-communication", label: "Property Communication" },
    //     { path: "automation-performance", label: "Automation Performance" },
    //   ],
    // },
    {
      label: "Logs",
      subItems: [
        { path: "message-log", label: "Text Message" },
        { path: "reply-logs", label: "AI Guest Reply" },
        { path: "chatbot-logs", label: "AI Chatbot" },
        { path: "webchat", label: "Webchat" },
      ],
    },
    {
      label: "Smart Locks",
      subItems: [
        { path: "smart-lock-logs", label: "Codes Generated" },
        { path: "smart-lock-activities", label: "Activities" },
      ],
    },
    {
      label: "Guestbook Analytics",
      subItems: [
        { path: "guestbook-views", label: "Guestbook Views" },
        { path: "guestbook-by-guest", label: "Guestbook Views By Guest" },
        { path: "guestbook-by-device", label: "Guestbook Views By Device" },
        { path: "trip-planning", label: "Trip Planning" },
        { path: "extras-views", label: "Extras Views" },
        { path: "home-guide-views", label: "Home Guide Views" },
        { path: "area-guide-views", label: "Area Guide Views" },
      ],
    },
    ...(hasFlag("performance-analytics")
      ? [{
        label: "Performance Analytics",
        subItems: [
          { path: "performance-overview", label: "Overview" },
          { path: "revenue-trends", label: "Revenue Trends" },
          { path: "booking-trends", label: "Booking Trends" },
          { path: "channel-performance", label: "Channel Performance" },
          { path: "property-performance", label: "Property Performance" },
          { path: "repeat-guests", label: "Repeat Guests" },
          { path: "revenue-opportunities", label: "Revenue Opportunities" },
        ],
      }]
      : []),
    {
      label: "Guest Responses",
      subItems: [
        { path: "fivestar-rating", label: "Five Star Ratings" },
        { path: "surveys", label: "Survey Reports" },
        { path: "check-in-out", label: "Check-In/Check-Out" },
        { path: "request-check-in-out", label: "Request Early Check-In/Late Check-Out" },
      ],
    },
    {
      label: "Messages Sent",
      subItems: [
        { path: "automated-sms-sent", label: "Automated Text" },
        { path: "automated-email-sent", label: "Automated Emails" },
        { path: "extend-stay", label: "Extend Stays Text" },
      ],
    },
    {
      label: "Extras Orders",
      subItems: [
        { path: "orders-details", label: "Order Details" },
        { path: "orders-income-by-item", label: "Income By Item" },
      ],
    },
    { path: "booking-source-mapping", label: "Booking Source Mapping" },
    { path: "message-audit", label: "Message Audit" },
  ];
};
